import PropTypes from "prop-types";
import React from "react";
import { Row, Col, FormGroup, FormLabel, FormText } from "react-bootstrap";
import Select from "react-select";

import { UpgradeConfig } from "./device-config";

class VersionSelector extends React.PureComponent {
  static get propTypes() {
    return {
      available_versions: PropTypes.array,
      versionSelectorEnabled: PropTypes.bool,
      onSelectType: PropTypes.func.isRequired,
      onSelectVersion: PropTypes.func.isRequired,
      startPage: PropTypes.number,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      showVersionDropdown: true,
      selectedOperation: props.startPage,
      selectedVersion: "",
    };
    this.handleSelectType = this.handleSelectType.bind(this);
    this.handleSelectVersion = this.handleSelectVersion.bind(this);
  }

  componentDidMount() {
    this.props.onSelectType(this.props.startPage);
  }

  handleSelectType(selectedOption) {
    const selectedOperation = selectedOption.value;
    this.props.onSelectType(selectedOperation);

    // Reset the second dropdown's state
    this.setState({
      selectedOperation,
      selectedVersion: null,
      showVersionDropdown:
        UpgradeConfig[selectedOption.value].showVersionDropdown,
    });
  }

  handleSelectVersion(selectedOption) {
    const selectedVersion = selectedOption ? selectedOption.value : "";

    this.setState({
      selectedVersion,
    });

    this.props.onSelectVersion(selectedVersion);
  }

  render() {
    const { versionSelectorEnabled, available_versions } = this.props;
    const { selectedOperation, showVersionDropdown } = this.state;

    if (!versionSelectorEnabled) {
      return null;
    }
    const isUpgrade = UpgradeConfig[selectedOperation].isUpgrade;
    const upgradeOrDowngradeText = isUpgrade ? "upgrade" : "downgrade";
    const versionHelpText = `Required. Select the player version to ${upgradeOrDowngradeText} to.
       Only select recent versions are available.`;
    const downgradeWarning = isUpgrade
      ? ""
      : UpgradeConfig[selectedOperation].topWarning;

    const operationOptions = UpgradeConfig.map((configItem, index) => ({
      configItem,
      originalIndex: index,
    }))
      .filter(({ configItem }) => configItem.showInOperationDropdown)
      .map(({ configItem, originalIndex }) => ({
        value: originalIndex,
        label: configItem.label,
      }));

    const versionOptions = (available_versions || [])
      .slice(isUpgrade ? 0 : 1) // Drop the highest version for downgrade
      .map((version) => ({
        value: version,
        label: version,
      }));

    return (
      <div>
        {/* Display warning if downgrading */}
        {!isUpgrade && (
          <div
            style={{
              backgroundColor: "orange",
              color: "white",
              padding: "10px",
              marginBottom: "15px",
              borderRadius: "5px",
              wordWrap: "break-word",
              textAlign: "center",
            }}
          >
            {downgradeWarning}
          </div>
        )}

        {/* Dropdowns for update type and version */}
        <Row>
          <Col xs={6}>
            <FormGroup>
              <FormLabel>Select Operation</FormLabel>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={operationOptions}
                onChange={this.handleSelectType}
                placeholder="Select operation"
                isClearable={false}
                value={operationOptions.find(
                  (option) => option.value === this.state.selectedOperation,
                )}
              />
              <FormText>
                Required. Please select the operation to take.
              </FormText>
            </FormGroup>
          </Col>

          {showVersionDropdown && (
            <Col xs={6}>
              <FormGroup>
                <FormLabel>Select New Player Version</FormLabel>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  options={versionOptions}
                  onChange={this.handleSelectVersion}
                  value={
                    this.state.selectedVersion
                      ? versionOptions.find(
                          (option) =>
                            option.value === this.state.selectedVersion,
                        )
                      : null
                  }
                  placeholder="Select version"
                  isClearable={false}
                />
                <FormText>{versionHelpText}</FormText>
              </FormGroup>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

export { VersionSelector };
